import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import axios from "axios";
import App from "./App";
import { store, persistor } from "./store";
import { ACTIONS, API_URL, STORAGE } from "./_config";
import "./index.css";

function renderApp() {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    // <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </PersistGate>
    </Provider>,
    // </React.StrictMode>
  );
}

// On startup, validate any persisted token and hydrate user state
const token = localStorage.getItem(STORAGE);
if (token) {
  axios({
    method: "GET",
    url: API_URL.AUTH.PROFILE,
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((success) => {
      const adminData = success.data?.data?.admin ?? success.data?.data?.user ?? null;
      store.dispatch({ type: ACTIONS.AUTH.ME, payload: adminData });
      renderApp();
    })
    .catch(() => {
      localStorage.removeItem(STORAGE);
      store.dispatch({ type: ACTIONS.AUTH.LOGOUT });
      renderApp();
    });
} else {
  renderApp();
}
